/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-12-21 15:01:20
 * @LastEditors: shimnx
 * @LastEditTime: 2022-07-14 18:04:18
 */
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../@core/auth/auth.service';

@Component({
  selector: 'app-no-permission',
  template: '<h1>401 No permission please sign in sign status</h1>'
})
export class NoPermissionComponent {
  constructor(public translate: TranslateService, private authService: AuthService) {}
}
